import * as amplitude from '@amplitude/analytics-browser';

export const initAmplitudeAnalytics = (key?: string) => {
  if (!key) return;

  amplitude.init(key, undefined, {
    autocapture: {
      attribution: true,
      pageViews: { trackHistoryChanges: 'pathOnly' },
    },
  });
};
